<template>
  <!-- new code -->
  
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
   <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    <v-card>
      <v-toolbar class="toolbar">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Edit Fill In The Blanks Assignment</v-toolbar-title>
        <!-- <v-toolbar-items>
            <v-btn dark text @click="show = false">Close</v-btn>
          </v-toolbar-items> -->
      </v-toolbar>
      <div style="margin: 5px">
        <!-- Add -->
        <v-card>
          <br />
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="card-border">
              <v-row>
                <v-col cols="12" sm="3" class="pt-5 m-0"> </v-col>
                <v-col cols="12" sm="4" v-if="weightage_show">
                  <p class="tx-bold">Weightage</p>
                  <v-text-field
                    class="p-0 m-0"
                    v-model.trim="weightage"
                    type="number"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- {{ this.answer}} -->
                <v-col cols="12" sm="6" md="6">
                  <span>Question Statement</span><br />
                  <v-textarea
                    v-model="question"
                    @keypress="countfillinthblank()"                   
                    placeholder="Enter Question Statement"
                  ></v-textarea>
                   <!-- @keyup.delete="countfillinthblank()" -->
                  <p class="note-error">
                    Note: Please enter 3 minus symbol simultaneously to make it
                    a blank. --- indicated blanks area within the question.
                  </p>
                  <p class="note-text">
                    Example : "--- is the capital of India."
                  </p>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <span v-if="answer.length > 0">Answer :</span>
                  <span v-for="t in answer" :key="t">
                    <v-text-field
                      v-model="t.correct_answer"
                      @change="addans($event)"
                      placeholder="Enter Answer Text"
                      hint="Mumbai, pune"
                    ></v-text-field>
                  </span>
                </v-col>
                 <!-- <v-col cols="12" sm="1" md="1"></v-col> -->
                  <v-col cols="12" sm="2" md="2">
                    <span>Weightage :</span><br />
                    <span v-for="t in answer" :key="t">
                      <p></p>
                      <v-text-field
                        outlined
                        dense
                        type="number"
                        v-model="t.ans_weightage"
                        @change="calculatemarks()"
                      ></v-text-field>
                    </span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="button" @click="save">Save</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
        <v-dialog v-model="dialog" hide-overlay persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Please Wait File is Uploding...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- root DIV -->
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { VueMathjax } from "vue-mathjax";
import "@/assets/css/color.css";
export default {
  components: {
    "vue-mathjax": VueMathjax,
  },
  props: ["multiword_id", "value"],
  data: () => ({
    editorConfig: {
      height: "70px",
      extraPlugins: "mathjax",
      mathJaxLib:
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
    },
    weightage: 1,
    marks_list: [
      { id: 1, marks: "1" },
      { id: 2, marks: "2" },
      { id: 3, marks: "3" },
      { id: 4, marks: "4" },
      { id: 5, marks: "5" },
      { id: 6, marks: "6" },
      { id: 7, marks: "7" },
      { id: 8, marks: "8" },
      { id: 9, marks: "9" },
      { id: 10, marks: "10" },
    ],
    answer: [],
    dialog: false,
    courseId: null,
    all_data: null,
    dashfound: [],
    question: null,
    date: null,
    ans: [],
    is_active: null,
    weightage_show: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,total_weightage:0
  }),
  methods: {
     calculatemarks() {
      this.total_weightage = 0;
      for (var i = 0; i < this.answer.length; i++) {
        // alert(this.option_weightage[i])
        if (this.answer[i].ans_weightage != null) {
          this.total_weightage += parseFloat(this.answer[i].ans_weightage);
        }
      }
    },
    deletefillinthblank(){
      let text = this.question;
      let pattern = /---/g;
      let found = text.match(pattern);
      //alert(found.length)
      for (var i = 0; i < found.length; i++) {
         this.answer.splice(i,1);
      }
      this.dashfound = found.length;
     // this.answer.splice();
    },
    countfillinthblank() {
      let text = this.question;
      let pattern = /---/g;
      let found = text.match(pattern);
      this.dashfound = found.length;
      if(this.dashfound>this.answer.length){
        this.answer.push({
          mwa_id: null,
          correct_answer: "",
          ans_weightage: 0,
      });
      }
    },
    addans(e) {
      this.ans.push(e.target.value);
      this.answer = this.ans;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showsnackbar(msg, "error", 5000);
    },
    save() {
      this.calculatemarks();
      if (this.question == null) {
        alert("Enter Question Statement");
      } else if ($.isEmptyObject(this.answer)) {
        alert("Enter Model Answer or File");
      } else {
        const data = {
          current_course: this.courseId,
          q_id: this.multiword_id,
          question: this.question,
          total_weightage: this.total_weightage,
          answer: this.answer,
        };
        axios
          .post("/LiveClass/saveEditMWA", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("green", "Updated Successfully"); // show snackbar
              this.initCall();
            }
          })
          .catch((error) => {
            this.showSnackbar("red", "Something went wrong..."); // show snackbar
          })
          .finally(() => {});
      }
    },
    reset() {
      this.question = null;
      this.answer = [];
    },
    initCall() {
      const data = {
        q_id: this.multiword_id,
      };
      axios
        .post("/LiveClass/getQuizQuestionData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.proj_data = res.data;
            this.weightage = res.data.weightage;
            this.question = res.data.question;
            this.answer = res.data.mwadata;
          } else {
            // this.showsnackbar(res.data.snackbar, "error", 5000);
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => {
          this.countfillinthblank();
          this.calculatemarks();
        });
    },
  },
  mounted() {
    this.initCall();
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.note-error {
  color: #ff5e00;
  font-size: 16px;
}
.note-text {
  color: #c24e0b;
  font-size: 18px;
}
.row {
  margin: 1rem !important;
  padding: 0%;
}
.col-mr {
  margin: 0% !important;
  padding: 0%;
}
.toolbar {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  padding: 5px;
  margin: 1rem !important;
  width: auto;
}
.btn-submit:hover {
  background-color: #ff5e00 !important;
  color: #ffffff !important;
}
.radiospace {
  margin: 0.5rem !important;
  padding: 0%;
}
.span-mr {
  margin: 1rem !important;
  padding: 0px;
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  padding: 5px;
  margin: 1rem !important;
  width: auto;
}
.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}
.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}
.msg {
  color: red;
}
.card {
  background: darkblue;
  color: white;
}
.btn-submit-align {
  float: right;
  margin: 1rem !important;
}
.btn-submit:hover {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
.name {
  color: #ffb500;
  font-weight: bold;
  letter-spacing: 1px;
}
v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}
th {
  color: white;
  font-weight: bold;
}
td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: left;
}
v-row {
  padding: 0px;
}
v-col {
  padding: 0px;
  margin: 0px;
}
span {
  padding: 0px;
  margin: 0px;
}
v-chip {
  width: auto;
}
</style> 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 